import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/animation-width',{init:init})

function init(obj){
  setTimeout(function(){
    obj.css('transition',"all 0.5s")
    obj.css('width',obj.attr('data-animation-width'))
    
  },50)
}